import { defineStore } from 'pinia';
import _ from 'lodash';

export const useBannersStore = defineStore('bannersStore', {
	state: () => ({
		hero_banners: []
	}),
	getters: {
		getLiveCasinoHeroBanners(state) {
			return _.chain(state.hero_banners).filter({ 'banner_slot_slug': 'live_casino' }).sortBy('sort', 'asc').value();
		},
		getRacingBanner(state) {
			return _.chain(state.hero_banners).filter({ 'banner_slot_slug': 'racing' }).sortBy('sort', 'asc').value();
		},
		homepage_banners() {
			const hero_banners = this.hero_banners.filter(banner => banner.banner_slot_slug === 'homepage');
			return _.sortBy(hero_banners, 'sort');
		},
		getCasinoHeroBanners: (state) => (slot_slug = 'casino') => {
			const banners = _.chain(state.hero_banners).filter({ banner_slot_slug: slot_slug }).sortBy('sort', 'asc').value();

			if (banners.length === 0 && slot_slug !== 'casino') {
				return _.chain(state.hero_banners).filter({ banner_slot_slug: 'casino' }).sortBy('sort', 'asc').value();
			}

			return banners;
		},
		is_button_visible: (state) => (banner_id) => {
			const is_device_mobile = state.is_mobile;
			const banner = state.hero_banners.find(b => b.id == banner_id);

			if (!banner) return false;
			if (!banner.button_text) return false;
			if (!banner.button_url) return false;
			if (is_device_mobile) return banner.button_visibility == 'mobile' || banner.button_visibility == 'both';
			else return banner.button_visibility == 'desktop' || banner.button_visibility == 'both';
		},
		is_mobile() {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true;
			}

			return false;
		}
	},
	actions: {
		fetchHeroBanners() {
			const device_type = this.is_mobile ? 'mobile' : 'desktop';

			return global.axios.get(process.env.VUE_APP_API_URL + '/banners/hero/' + device_type).then((response) => {
				this.hero_banners = response.data.data
				return Promise.resolve(response.data.data)
			}).catch((error) => {
				return Promise.reject(error);
			})

		},
	},
})